/**
 * GIS file format types supported by the GeoVera platform.
 *
 * Used as the internal interchange format identifier for import/export operations.
 */
export type GISFormat = 'kml' | 'shapefile' | 'geopackage' | 'geojson' | 'gpx';

/**
 * Result of format detection, including confidence level.
 */
export interface FormatDetectionResult {
  format: GISFormat;
  confidence: 'high' | 'medium' | 'low';
  detectedBy: 'extension' | 'content' | 'both';
}

/**
 * Error thrown when a file format cannot be detected.
 */
export class UnsupportedFormatError extends Error {
  readonly filename?: string;
  constructor(message: string, filename?: string) {
    super(message);
    this.name = 'UnsupportedFormatError';
    this.filename = filename;
  }
}
